(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3287],{

/***/ 4725:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/brands/[brand]",
      function () {
        return __webpack_require__(382);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4804:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C2": function() { return /* binding */ BannerBox; },
/* harmony export */   "UP": function() { return /* binding */ BannerContainer; },
/* harmony export */   "cW": function() { return /* binding */ BannerImage; },
/* harmony export */   "gY": function() { return /* binding */ BannerSlider; }
/* harmony export */ });
/* harmony import */ var _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4337);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9447);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  width: 100vw;\n  padding: 2.125rem 1rem;\n  margin-top: -1rem;\n  background-color: blue-100;\n\n  @media (min-width: desktop) {\n    padding: 1.75rem 2rem 1.375rem;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  top: 5rem;\n  width: 88%;\n  padding: 1.75rem 1.5rem 2rem;\n  border-radius: 24px;\n  background-color: white;\n  z-index: 1;\n\n  @media (min-width: desktop) {\n    max-width: 420px;\n    padding: 3rem 3.25rem;\n    top: 5rem;\n\n    p {\n      margin: 1rem 0 0;\n    }\n  }\n\n  @media (max-width: desktop) {\n    position: static;\n    transform: translateY(-20%);\n\n    p {\n      margin: 2rem 0 0;\n    }\n  }\n\n  @media (min-width: tablet) and (max-width: desktop) {\n    max-width: 420px;\n    height: auto;\n    padding: 2rem;\n    top: 5rem;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  width: 100%;\n  /* height: min(50vw, 465px); */\n\n  @media (min-width: desktop) {\n    left: 15rem;\n  }\n\n  @media (min-width: desktop) and (max-width: 1064.98px) {\n    width: 720px;\n  }\n\n  @media (min-width: 1065px) {\n    width: 750px;\n  }\n\n  @media (min-width: lg_desktop) {\n    width: 890px;\n  }\n\n  img {\n    border-radius: 12px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  @media (min-width: desktop) {\n    margin-top: 2rem;\n    margin-bottom: 2rem;\n  }\n\n  @media (max-width: desktop) {\n    position: initial;\n  }\n\n  .swiper-pagination-bullets {\n    bottom: 2rem;\n\n    @media (max-width: desktop) {\n      bottom: 1rem;\n    }\n  }\n\n  .swiper-pagination-bullet {\n    transform: scale(1.3);\n    margin: 0 10px !important;\n  }\n\n  .swiper-pagination-bullet-active {\n    background-color: teal-300;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var BannerContainer = _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].sectionBox */ .ZPm.sectionBox(_templateObject());
var BannerBox = _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].divBox */ .ZPm.divBox(_templateObject1());
var BannerImage = _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].divBox */ .ZPm.divBox(_templateObject2());
var BannerSlider = (0,_xstyled_styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZPm)(swiper_react__WEBPACK_IMPORTED_MODULE_1__/* .Swiper */ .t)(_templateObject3());


/***/ }),

/***/ 382:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ Brand; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./hooks/UI/useScrollRestoration.js
var useScrollRestoration = __webpack_require__(4751);
// EXTERNAL MODULE: ./hooks/products/usePagination.js
var usePagination = __webpack_require__(8510);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useLazyQuery.js
var useLazyQuery = __webpack_require__(3359);
// EXTERNAL MODULE: ./graphql/queries/index.js + 28 modules
var queries = __webpack_require__(4462);
// EXTERNAL MODULE: ./node_modules/jotai/esm/index.js
var esm = __webpack_require__(1131);
// EXTERNAL MODULE: ./global/store.js
var store = __webpack_require__(561);
// EXTERNAL MODULE: ./hooks/products/useProductPages.js
var useProductPages = __webpack_require__(8812);
;// CONCATENATED MODULE: ./hooks/brands/useBrandCatalogue.js
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}






function useBrandCatalogue() {
    var ref, ref1;
    var router = (0,next_router.useRouter)();
    var lang = router.locale ? router.locale : "et";
    // Get products
    var currentPage = (0,esm/* useAtomValue */.Dv)(store/* currentPageAtom */.ef);
    var ref2 = _slicedToArray((0,useLazyQuery/* useLazyQuery */.t)(queries/* BRAND_PRODUCTS */.K3, {
        variables: {
            brand: (ref = router.query) === null || ref === void 0 ? void 0 : ref.id,
            currentPage: currentPage,
            sortBy: {
                bestsellers: "DESC"
            }
        },
        context: {
            fetchOptions: {
                method: "GET"
            },
            headers: {
                store: lang
            }
        },
        fetchPolicy: "cache-and-network"
    }), 2), getProducts = ref2[0], ref3 = ref2[1], data = ref3.data, loading = ref3.loading;
    var ref4 = (0,useProductPages/* default */.Z)(getProducts, data), products = ref4.products, pages = ref4.pages;
    return {
        products: products,
        loading: loading,
        pages: pages,
        count: data === null || data === void 0 ? void 0 : (ref1 = data.products) === null || ref1 === void 0 ? void 0 : ref1.total_count
    };
};

// EXTERNAL MODULE: ./global/constants.js
var constants = __webpack_require__(827);
;// CONCATENATED MODULE: ./hooks/brands/useBrandImages.js
function useBrandImages_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function useBrandImages_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function useBrandImages_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toArray(arr) {
    return useBrandImages_arrayWithHoles(arr) || _iterableToArray(arr) || useBrandImages_unsupportedIterableToArray(arr, i) || useBrandImages_nonIterableRest();
}
function useBrandImages_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return useBrandImages_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return useBrandImages_arrayLikeToArray(o, minLen);
}

function useBrandImages(source) {
    var bannerLink, promoImageLink;
    var images = source === null || source === void 0 ? void 0 : source.split("\r\n");
    if (images) {
        var getImage = function(index) {
            var ref;
            return (ref = images[index]) === null || ref === void 0 ? void 0 : ref.split("url=");
        };
        var ref2 = _toArray(getImage(0)), banner = ref2.slice(1);
        var ref1 = _toArray(getImage(1)), promo = ref1.slice(1);
        var getImagePath = function(text) {
            var ref, ref4;
            return (ref4 = (ref = text[0]) === null || ref === void 0 ? void 0 : ref.slice(1)) === null || ref4 === void 0 ? void 0 : ref4.split('"')[0];
        };
        var bannerImage = getImagePath(banner);
        var promoImage = getImagePath(promo);
        var getImageLink = function(image) {
            return "".concat(constants/* MAGENTO_URI */.mN, "/media/").concat(image);
        };
        bannerLink = getImageLink(bannerImage);
        promoImageLink = getImageLink(promoImage);
    }
    return {
        bannerLink: bannerLink,
        promoImageLink: promoImageLink
    };
};

// EXTERNAL MODULE: ./node_modules/@xstyled/styled-components/dist/styled-components.esm.js
var styled_components_esm = __webpack_require__(4337);
// EXTERNAL MODULE: ./components/SEO.js
var SEO = __webpack_require__(9831);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/UI/Layout/Container.js
var Container = __webpack_require__(6094);
// EXTERNAL MODULE: ./components/UI/Primitives/FlexBox.js
var FlexBox = __webpack_require__(5653);
// EXTERNAL MODULE: ./components/UI/Primitives/Headings.js
var Headings = __webpack_require__(7133);
// EXTERNAL MODULE: ./components/Banner/styles.js
var styles = __webpack_require__(4804);
;// CONCATENATED MODULE: ./components/Banner/BrandBanner.js







function BrandBanner(param) {
    var brand = param.brand, image = param.image, description = param.description;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* BannerContainer */.UP, {
        p: {
            _: "2.125rem 1rem",
            desktop: "2.125rem 2rem 3rem"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
            children: [
                image && /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* BannerImage */.cW, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: image,
                        layout: "fill",
                        alt: "Banner image"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FlexBox/* FlexBox */.h, {
                    justify: {
                        _: "center",
                        desktop: "start"
                    },
                    mb: {
                        desktop: "5rem"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* BannerBox */.C2, {
                        position: "relative",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Headings/* SectionTitle */.NZ, {
                                as: "h1",
                                children: brand === null || brand === void 0 ? void 0 : brand.value
                            }),
                            (brand === null || brand === void 0 ? void 0 : brand.image) && /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_components_esm/* Box */.xuv, {
                                as: "span",
                                position: "absolute",
                                right: 16,
                                top: 16,
                                zIndex: -1,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: brand === null || brand === void 0 ? void 0 : brand.image,
                                    alt: brand === null || brand === void 0 ? void 0 : brand.value,
                                    width: 100,
                                    height: 100,
                                    layout: "fixed",
                                    objectFit: "contain",
                                    priority: true
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_components_esm/* Box */.xuv, {
                                as: "p",
                                mt: {
                                    _: "4.5rem",
                                    desktop: "2.5rem"
                                },
                                children: description
                            })
                        ]
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./components/UI/ProductCard/index.js
var ProductCard = __webpack_require__(681);
// EXTERNAL MODULE: ./components/UI/Layout/index.js
var Layout = __webpack_require__(3793);
// EXTERNAL MODULE: ./components/Catalogue/Pagination.js
var Pagination = __webpack_require__(234);
// EXTERNAL MODULE: ./components/UI/Skeletons/SkeletonProductCard.js
var SkeletonProductCard = __webpack_require__(3327);
// EXTERNAL MODULE: ./components/UI/Skeletons/MobileSkeletonProductCard.js
var MobileSkeletonProductCard = __webpack_require__(2298);
// EXTERNAL MODULE: ./components/UI/ProductCard/MobileProductCard.js
var MobileProductCard = __webpack_require__(1459);
;// CONCATENATED MODULE: ./pages/brands/[brand].js
function _brand_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _brand_arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _brand_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _brand_iterableToArray(arr) || _brand_unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _brand_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _brand_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _brand_arrayLikeToArray(o, minLen);
}
















var __N_SSP = true;
function Brand(param) {
    var brand = param.brand, categories = param.categories, locale = param.locale;
    var et;
    var lt;
    var en;
    var desc = brand.short_description;
    if (brand && brand.short_description) {
        if (desc.includes("[lt]")) {
            var splitLT = desc.split("[lt]");
            lt = splitLT[1];
            et = splitLT[0];
            if (lt.includes("[en]")) {
                var splitLT2 = lt.split("[en]");
                lt = splitLT2[0];
                en = splitLT2[1];
            }
        }
        if (!desc.includes("[lt]") && desc.includes("[en]")) {
            var splitLT3 = desc.split("[en]");
            en = splitLT3[1];
            et = splitLT3[0];
        }
        if (locale) {
            if (locale == "lt") {
                desc = lt ? lt : et;
            }
            if (locale == "en") {
                desc = en ? en : et;
            }
            if (locale == "et") {
                desc = et ? et : et;
            }
        } else {
            desc = et ? et : brand.short_description;
        }
    }
    if (!desc) {
        desc = brand.short_description;
    }
    // Get products sorted by popularity
    var ref = useBrandCatalogue(), products = ref.products, loading = ref.loading, pages = ref.pages, count = ref.count;
    // Get image links
    var bannerLink = useBrandImages(brand === null || brand === void 0 ? void 0 : brand.description).bannerLink;
    var skeletons = _toConsumableArray(Array(24));
    // Restore scroll position when returning from a product
    (0,useScrollRestoration/* default */.Z)({
        data: products
    });
    // Paginate products
    (0,usePagination/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        categories: categories,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SEO/* default */.Z, {
                seo: _objectSpread({
                    title: "".concat(brand === null || brand === void 0 ? void 0 : brand.value, " - Baltbaby")
                }, desc ? {
                    description: desc
                } : null)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BrandBanner, {
                brand: brand,
                description: desc,
                image: bannerLink
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "product_container"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
                display: {
                    _: "block",
                    desktop: "none"
                },
                mb: 72,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_components_esm/* Box */.xuv, {
                        display: {
                            _: "grid",
                            desktop: "none"
                        },
                        gridTemplateColumns: {
                            _: "1fr",
                            lg_tablet: "1fr 1fr"
                        },
                        justifyItems: {
                            sm_tablet: "center"
                        },
                        columnGap: "0.75rem",
                        rowGap: "0.1rem",
                        p: {
                            _: "0 1rem",
                            desktop: 0
                        },
                        children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: skeletons.map(function(_, i) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileSkeletonProductCard/* default */.Z, {
                                    maxW: 450,
                                    minH: 150
                                }, i);
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: products === null || products === void 0 ? void 0 : products.map(function(product) {
                                if (product !== null) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileProductCard/* default */.Z, {
                                        product: product,
                                        maxW: 450,
                                        minH: 150
                                    }, product === null || product === void 0 ? void 0 : product.sku);
                                }
                            })
                        })
                    }),
                    pages > 0 && count > 24 && products && (products === null || products === void 0 ? void 0 : products.length) !== count && /*#__PURE__*/ (0,jsx_runtime.jsx)(FlexBox/* FlexBox */.h, {
                        align: "center",
                        justify: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination/* default */.Z, {
                            pages: pages
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
                display: {
                    _: "none",
                    desktop: "block"
                },
                mb: 72,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_components_esm/* Box */.xuv, {
                        id: "brand_products_desktop",
                        display: {
                            _: "none",
                            desktop: "grid"
                        },
                        gridTemplateColumns: {
                            desktop: "repeat(3, 33.33%)",
                            lg_desktop: "repeat(4, 25%)"
                        },
                        columnGap: "1rem",
                        rowGap: "2rem",
                        p: "1.5rem 1rem 0 0",
                        children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: skeletons.map(function(_, i) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonProductCard/* default */.Z, {}, i);
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: products === null || products === void 0 ? void 0 : products.map(function(product, i) {
                                if (product !== null) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCard/* default */.Z, {
                                        product: product,
                                        imageSize: {
                                            width: 1000,
                                            height: 1040
                                        },
                                        w: 300,
                                        border: "none"
                                    }, i);
                                }
                            })
                        })
                    }),
                    pages > 0 && count > 24 && products && (products === null || products === void 0 ? void 0 : products.length) !== count && /*#__PURE__*/ (0,jsx_runtime.jsx)(FlexBox/* FlexBox */.h, {
                        align: "center",
                        justify: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination/* default */.Z, {
                            pages: pages
                        })
                    })
                ]
            })
        ]
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4337,1664,7536,9669,5675,3305,9447,2483,5275,1979,9085,8435,1459,883,9774,2888,179], function() { return __webpack_exec__(4725); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);